export default __webpack_public_path__ + "static/media/croptop-large-right-toosmall.a760ab17.jpg";